import { drop } from "lodash";

export function getRoleFromJson(content) {
  const dropSelects = content.Opening.Options;
  /*
  const dropSelects = content.Opening.DropdownSelect.map((roleObj) => {
    for (let lang in roleObj) {
      if (roleObj.trim() === roleObj) continue;

      roleObj = roleObj.trim();
    }

    delete roleObj.element;

    return roleObj;
  });
*/
  return dropSelects;
}
